import React, { FC } from 'react';

import { Grid, AccordionDetails } from '@material-ui/core';

import { IEventEnrollment } from '../../../../../../../store/admin/eventEnrollments/store';
import { ITeam } from '../../../../../../../store/admin/eventTeams/store';

import PlayerCard from '../../../../../../../components/PlayerCard/PlayerCard';
import { TeamCard } from '../../../../../../../components/TeamCard/TeamCard';
import { isEventEnrollment } from '../../../../../../../contrib/Utils/isEventEnrollment';
import { useRouteInfoState } from '../../../../../../../components/RouteInfo/Context/RouteInfo.context';
import { TeeSheetCreatorProvider } from '../../../../TeeSheetCreator/Context/TeeSheetCreator.context';
import { useAdminRound } from '../../../../../../../contrib/Hooks/useAdminRound.hook';
import { IProps } from '../FlightItem';

interface IFlightItemDetailsProps extends Pick<IProps, 'enrollments'> {
  showListValue: boolean;
}

const FlightItemDetails: FC<IFlightItemDetailsProps> = props => {
  const { enrollments, showListValue } = props;

  const { roundId } = useRouteInfoState();

  const [round] = useAdminRound(roundId);

  return enrollments.length ? (
    <AccordionDetails className="panel-content">
      <Grid className="flight-enrollents" container={true} spacing={2}>
        {showListValue ? (
          (enrollments as any[]).map((enrollment: ITeam | IEventEnrollment) => (
            <Grid
              className="enrollment-wrapper"
              key={`flight-enrollment-${enrollment.id}`}
              item={true}
              xs={12}
              sm={6}
              md={4}
            >
              {isEventEnrollment(enrollment) ? (
                round ? (
                  <PlayerCard
                    item={enrollment}
                    key={`playerCard-${enrollment.id}`}
                    context={{ round }}
                  />
                ) : (
                  <></>
                )
              ) : (
                <TeeSheetCreatorProvider>
                  <TeamCard
                    context="flights"
                    team={enrollment}
                    hideActions={true}
                    displayChangeTeamFlight={true}
                  />
                </TeeSheetCreatorProvider>
              )}
            </Grid>
          ))
        ) : (
          <></>
        )}
      </Grid>
    </AccordionDetails>
  ) : (
    <></>
  );
};

export default FlightItemDetails;
